module.exports = __webpack_public_path__ + "static/media/prochazkova.8ec909d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/prochazkova.jpg
// module id = 490
// module chunks = 0